import WithRender from "../../templates/imageEditor/margintotal.html";
import { mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters([
      "getFormat",
      "getMargin",
      "getEditor",
      "canvasFormatLeft",
      "canvasFormatDimByFormat"
    ]),
    totalWidth: function () {
      return this.getMargin.left + this.getMargin.right + this.getFormat.width;
    },
    totalHeight: function () {
      return this.getMargin.left + this.getMargin.right + this.getFormat.width;
    },
    getMarginViewStyle: function () {
      var size = this.canvasFormatDimByFormat;
      var corrections = this.getCorrections();
      var result = {
        width: Math.round(size.width) + "px",
        height: Math.round(size.height) + "px",
        top: Math.round(size.top + corrections.top) + "px",
        left: Math.round(size.left + corrections.left) + "px"
      };

      return result;
    }
  },
  methods: {
    getCorrections: function () {
      return {
        left: this.canvasFormatLeft,
        top: this.getEditor.dim.canvasDimByFormat.top
      };
    }
  }
});
